import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import track from 'react-tracking';
import { FormattedMessage, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';
import CloudflareImage from '@prospectus/common/ui/CloudflareImage';

function AppDownloadLinks({
  intl: {
    locale,
  },
  className,
}) {
  const appleIconFile = locale === 'es' ? 'apple-store-badge-es.svg' : 'apple-store-badge-en.svg';
  const googleIconFile = locale === 'es' ? 'google-play-badge-es.png' : 'google-play-badge-en.png';

  return (
    <div className={classNames('app-download-links', className)}>
      <ProspectusLink
        href="https://itunes.apple.com/us/app/edx/id945480667?mt=8"
        className="image-link"
        analytics={{
          eventName: 'edx.bi.link.mobile_app.clicked',
          linkProps: {
            category: 'outbound_link',
            label: 'iOS',
          },
        }}
      >
        <FormattedMessage
          id="prospectus.mobile.apple-badge.download"
          description="Label for a link to download the edX app on the apple app store."
          defaultMessage="Download on the App Store"
        >{text => <CloudflareImage url={`/images/logos/${appleIconFile}`} className="app-download-badge apple" height={40} width={120} description={text} />}
        </FormattedMessage>
      </ProspectusLink>

      <ProspectusLink
        href="https://play.google.com/store/apps/details?id=org.edx.mobile"
        className="image-link"
        analytics={{
          eventName: 'edx.bi.link.mobile_app.clicked',
          linkProps: {
            category: 'outbound_link',
            label: 'Android',
          },
        }}
      >
        <FormattedMessage
          id="prospectus.mobile.google-badge.download"
          description="Label for a link to download the edX app on Google Play."
          defaultMessage="Get it on Google Play"
        >{text => <CloudflareImage url={`/images/logos/${googleIconFile}`} className="app-download-badge google" description={text} />}
        </FormattedMessage>
      </ProspectusLink>
    </div>
  );
}

AppDownloadLinks.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
};

AppDownloadLinks.defaultProps = {
  className: '',
};
export default track({
  component: 'app download links',
})(injectIntl(AppDownloadLinks));
